var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticStyle:{"width":"100%","height":"100%","z-index":"10000","top":"0","left":"0","position":"fixed"}},[_c('v-progress-linear',{attrs:{"color":"white","height":"5","indeterminate":""}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }